import { RestService } from './RestService';

export const AuthService = {
  login: async (username: string, password: string) => {
    return await RestService.post('/auth/login', { username, password });
  },
};
